import React, { useMemo, useState } from "react";
import Stack from "@mui/material/Stack";
import Badge from "@mui/material/Badge";
import {
  AlertComponent,
  SearchInputComponent,
  SelectInputComponent,
} from "../../../common/components";
import FilterIcon from "../../../assets/icons/filter-icon.svg";
import { CustomerFilterProps } from "./customer-filter.props";
import {
  allCustomersOptions,
  createCustomersOptions,
  actionsOptions,
  createCustomersButtonOptions,
} from "./customer-filter.constant";
import "./customer-filter.scss";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../constants/routes";
import SplitButtonComponent from "../../../common/components/split-button-component/split-button";
import { useResourcePermissions } from "../../../common/hooks/resource-permissions";
import MODULES from "../../../constants/modules";
import ImportModal from "../../../common/components/import-modal/import-modal";
import { uploadFile } from "../../../api/customer";
import { useSetLoading } from "../../../common/hooks/appearance";
import { useLogin } from "../../../common/hooks/useUser";
import useMediaQuery from '@mui/material/useMediaQuery';

const CustomerFilter: React.FC<CustomerFilterProps> = (props: any) => {
  const {
    isOpenFilter,
    setIsOpenFilter,
    selectedCustomersFilter,
    selectedAllCustomers,
    setSelectedAllCustomers,
    selectedCreateCustomers,
    setSelectedCreateCustomers,
    selectedActions,
    setSelectedActions,
    onSearch,
    searchRef,
    resetSearch,
    isResetSearch,
    disabled,
    handleActionTrigger,
    disableSelectedCustomers,
    setIsShowCreateCustomer,
    isShowCreateCustomer,
    selectOpen,
    setSelectOpen,
    totalCustomers,
    showImportModal,
    setShowImportModal,
    isShowCreateCustomerSection,
    setIsShowCreateCustomerSection,
    fetchCustomers,
  } = props;
  const navigate = useNavigate();
  const { canWrite, canDelete } = useResourcePermissions(MODULES.LEAD_DETAILS);
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<
    "error" | "success" | "info" | "warning"
  >("info");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const userDetails = useLogin();
  const userRole = userDetails.userDetails.roles.role;
  const isMobile = useMediaQuery('(max-width:768px)');
  const { canExport } = useResourcePermissions(MODULES.EXPORT);
  const filteredActionsOptions = actionsOptions.filter((option) => {

    if (option.value === "Export Customers" && !canExport) {
      return false;
    }

    if ((option.value === "Archive" && !canDelete)) {
      return false;
    }
    if(option.value !== "Archive" && !canWrite) return false
    return true;
  });

  const handleAlertClose = () => {
    setAlertOpen(false);
  };
  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);
  const handleOpen = () => {
    if (setSelectOpen) setSelectOpen(true);
  };
  const handleBlur = () => {
    if (setSelectOpen) setSelectOpen(false);
  };
  const handleCreateCustomerAction = (option: { value: string; id: number }) => {
    setSelectedCreateCustomers(option.value);
    if (option.value === "Import Customers") {
      setShowImportModal(true);
    } else if (option.value === "Social Media Import") {
      navigate(routes.SOCIALIMPORT_CUSTOMER);
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      handleUpload(event.target.files[0]);
    }
  };
  const handleUpload = async (file: File) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", file);
      await uploadFile(formData);
      setLoading(false);
      setAlertMessage("Uploaded successfully");
      setAlertType("success");
      setAlertOpen(true);
      setShowImportModal(false);
      fetchCustomers();
      setTimeout(() => {
        fetchCustomers();
      }, 5000);
      setSelectedCreateCustomers("Create Customers");
    } catch (error: any) {
      setLoading(false);
      setAlertMessage(error?.response?.data?.message || "Upload failed");
      setAlertType("error");
      setAlertOpen(true);
      setShowImportModal(false);
      setSelectedCreateCustomers("Create Customers");
      console.error(error);
    }
  };

  return (
    <div className="customer-list-search-filter-wrapper">
      {isMobile ? (
       <div className="search-filter-group">
      <div className="customer-list-search-wrapper">
        <SearchInputComponent
          placeholder="Search by Customer name, Email, Customer owner etc."
          onSearch={onSearch}
          isReset={isResetSearch}
          ref={searchRef}
        />
      </div>
      <div
          className="customer-list-icon-filter"
          onClick={() => setIsOpenFilter(!isOpenFilter)}
          tabIndex={0}
        >
          <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
            <Badge
              color="secondary"
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: "#887952",
                },
              }}
              badgeContent={selectedCustomersFilter}
            >
              <img src={FilterIcon} alt="Filter Icon" />
            </Badge>
          </Stack>
        </div>
      </div>) : (
        <div className="customer-list-search-wrapper">
          <SearchInputComponent
            placeholder="Search by Customer name, Email, Customer owner etc."
            onSearch={onSearch}
            isReset={isResetSearch}
            ref={searchRef}
          />
        </div>
      )}
      <div className="customer-list-filter-wrapper">
        {/* <div className="customer-list-customer-filter">
          <SelectInputComponent
            fieldName={"allCustomers"}
            value={[selectedAllCustomers || "All Customers"]}
            onChange={(e: any) => setSelectedAllCustomers(e)}
            multiple={false}
            options={allCustomersOptions}
          />
        </div> */}
        {!isMobile && (
        <div
          className="customer-list-icon-filter"
          onClick={() => setIsOpenFilter(!isOpenFilter)}
          tabIndex={0}
        >
          <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
            <Badge
              color="secondary"
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: "#887952",
                },
              }}
              badgeContent={selectedCustomersFilter}
            >
              <img src={FilterIcon} alt="Filter Icon" />
            </Badge>
          </Stack>
        </div>
        )}

        <div className="lead-list-create-filter">
          <SplitButtonComponent
            fieldName="createleads"
            createFieldName="createCustomers"
            value={selectedCreateCustomers || "Create Customer"}
            options={createCustomersOptions}
            optionsCreate={createCustomersButtonOptions(
              setIsShowCreateCustomer,
              isShowCreateCustomer,
              isShowCreateCustomerSection,
              setIsShowCreateCustomerSection
            )}
            onSelect={handleCreateCustomerAction}
            navigateTo={routes.CREATELEAD}
            resourceName={MODULES.CUSTOMER_PROFILE}
          />
          <ImportModal
            openModal={showImportModal}
            toggleModal={() => {
              setShowImportModal(false);
              setSelectedCreateCustomers("Create Customers");
            }}
            handleFileChange={handleFileChange}
            module="Customers"
          />
        </div>

        {(canDelete || canWrite || userRole === "Super Admin") &&<div className="customer-list-action-filter">
          <SelectInputComponent
            fieldName={"actions"}
            value={[selectedActions || "Actions"]}
            multiple={false}
            options={filteredActionsOptions}
            setSelectedActions={setSelectedActions}
            handleActionTrigger={handleActionTrigger}
            disableSelectedLeads={disableSelectedCustomers}
            selectOpen={selectOpen}
            handleOpen={handleOpen}
            handleBlur={handleBlur}
            disabled={disabled}
            totalLeads={totalCustomers}
            massActionsFor="customers"
            isEmailConfigured={userDetails?.isEmailConfigured}
          />
        </div>}
      </div>
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={handleAlertClose}
      />
    </div>
  );
};

export default CustomerFilter;
